import React from "react";
import Style from "./TaxiFinishedTravelDetail.module.css";
import { Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfo,
  faMapPin,
  faMoneyBillWave,
  faPhone,
} from "@fortawesome/fontawesome-free-solid";
import { separate } from "./../../Seprate/Seprate";
import Timer from "../Timer/Timer";
import moment from "moment-jalaali";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { faAddressBook } from "@fortawesome/free-solid-svg-icons";

const TaxiFinishedTravelDetail = ({ data }) => {
  return (
    <div className={Style.ComponentHolder}>
      <ul className={Style.ListHolder}>
        {data.map((item) => {
          return (
            <li key={item.id} className={Style.TravelHolder}>
              <div className={Style.DateHolder}>
                <FontAwesomeIcon icon={faCalendar} color="#d00d8f" />
                <p>
                  {moment.unix(parseInt(item.end_date)).format("jYYYY/jM/jD--HH:mm")}
                </p>
              </div>
              <section className={Style.PartHolder}>
                <Divider>آدرس</Divider>
                <p>
                  <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
                  مبدا:{item?.routes_description.split("**")[0]}
                </p>
                <p>
                  <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
                  مقصد:{item?.routes_description.split("**")[1]}
                </p>
                {data?.description && (
                  <p>
                    <FontAwesomeIcon icon={faAddressBook} color="#d00d8f" />
                     توضیحات:{data?.description}
                  </p>
                )}
              </section>

              <section className={Style.PartHolder}>
                <Divider>اطلاعات راننده</Divider>
                <div className={Style.DriverInfoHolder}>
                  <div className={Style.ProfileHolder}>
                    <img
                      src={`https://cdn.barest.ir/deliver/photo/${item.photo}.jpg`}
                      alt=""
                    />
                  </div>
                  <div className={Style.DriverInfoPartOne}>
                    <h6>{item.name}</h6>
                    <p>
                      {item.vehicle_model} {item.vehicle_color}
                    </p>
                  </div>
                  <div className={Style.DriverInfoParttwo}>
                    <p className={Style.CarPlateHolder}>{item.vehicle_plate}</p>
                  </div>
                </div>
              </section>

              <section className={Style.PartHolder}>
                <Divider>هزینه</Divider>
                <div className={Style.PricePartHolder}>
                  <p>
                    <FontAwesomeIcon icon={faMoneyBillWave} color="#d00d8f" /> 
                    <span style={{ color: "green" }}>
                      کرایه:{separate(item?.delivery)} تومان
                    </span>
                  </p>
                </div>
              </section>
              <section className={Style.PartHolder}>
                <Divider>وضعیت درخواست</Divider>
                <div className={Style.PricePartHolder}>
                  <p className={Style.RequestStatusHolder}>
                    <FontAwesomeIcon icon={faInfo} color="#d00d8f" /> 
                    {item.status === "4"
                      ? "اتمام سفر"
                      : item.status === "-2"
                      ? "سفر لغو شده"
                      : item.status === "-1"
                      ? "توسط راننده کنسل شد!"
                      : null}
                  </p>
                </div>
              </section>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TaxiFinishedTravelDetail;
